export default __webpack_public_path__ + "static/media/fNeutral20.abbf351d.png";